// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#bscdown{position:relative;background-color:rgba(6,30,93,.5);box-sizing:border-box;margin-right:10px}#bscdown,#bscdown .box{width:100%;height:100%}", ""]);
// Exports
module.exports = exports;
